import { ResourceType } from '@/enums/ResourceType';
import { _QueryResources } from '@/lib/datx-jsonapi-react';
import { Notification } from '@/resources/Notification';

export const getUnreadNotificationsQuery = (
  eventId: string,
  resourceType: ResourceType | Array<ResourceType>
) => () => {
  if (!eventId) return null;

  return [
    Notification,
    {
      filter: {
        event_id: eventId,
        scope: 'unread',
        ...(resourceType && { resource_type: resourceType }),
      },
      // we just need the info if unread notifications exists.
      // backend expects at least 1 attribute
      fields: {
        notifications: ['id'],
      },
    },
  ] as _QueryResources<Notification>;
};
